import {
	DOMOutputSpec,
	NodeSpec,
	Node as ProsemirrorNode
} from "prosemirror-model";
import { createStyleAttributeHandlers, StyleAttributes } from "./attributes/styleAttributes";

const stylesToCopy = {
	"border": "border",
	"borderCollapse": "border-collapse",
	"borderSpacing": "border-spacing",
	"padding": "padding",
	"paddingLeft": "padding-left",
	"paddingRight": "padding-right",
	"paddingTop": "padding-top",
	"paddingBottom": "padding-bottom",
	"width": "width",
	"height": "height",
	"background": "background",
	"backgroundColor": "background-color",
	"backgroundImage": "background-image",
	"display": "display"
} as const;

type TableStyleKeysToCopy = keyof typeof stylesToCopy;
export type TableNodeAttributes = StyleAttributes<TableStyleKeysToCopy>;

const {
	getStyleAttributes,
	setStyleAttributes,
	styleAttributeDefinitions,
	applyStyleAttributesToElement
} = createStyleAttributeHandlers(stylesToCopy);

export const table: NodeSpec = {
	attrs: {
		...styleAttributeDefinitions
	},
	content: "table_row+",
	tableRole: "table",
	isolating: true,
	group: "block",
	parseDOM: [
		{
			tag: "table",
			getAttrs(node: Node |string): {} | false {
				if (!(node instanceof HTMLTableElement)) {
					throw new Error("Expected HTMLTableElement at this point");
				}

				const styleAttributes: StyleAttributes<TableStyleKeysToCopy> = getStyleAttributes(node);

				return {
					...styleAttributes
				};
			},
		}
	],
	toDOM(node: ProsemirrorNode): DOMOutputSpec {
		const styleValue: string | undefined = setStyleAttributes(node.attrs as TableNodeAttributes);

		return [
			"table",
			{
				style: styleValue
			},
			["tbody", 0]
		];
	}
};

export {
	applyStyleAttributesToElement as applyTableStyleAttributesToElement
};